import { APIError } from 'src/api';

export interface EntityCollectionState<G> {
    isFetching: boolean;
    error?: APIError;
    items: G[];
}

export function entityCollectionDefaultState<G>(): EntityCollectionState<G> {
    return {
        isFetching: false,
        error: undefined,
        items: [],
    };
}
